import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Main category items", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://via.placeholder.com/200x50.png?text=category",
    alt: "category"
  })
], -1)
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = {
  key: 0,
  class: "col-3 small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "border p-2 mb-4 row"
        }, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", null, [
              _createVNode(_component_RouterLink, {
                to: { name: 'categories-details', params: { id: item.id } },
                class: "text-dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]),
          (_ctx.identityStore.isAdmin())
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_RouterLink, {
                  to: { name: 'categories-details', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Details")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" | "),
                _createVNode(_component_RouterLink, {
                  to: { name: 'categories-edit', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Edit")
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createTextVNode(" | "),
                _createVNode(_component_RouterLink, {
                  to: { name: 'categories-delete', params: { id: item.id } }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Delete")
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}